import { inject, Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { fromEvent } from 'rxjs';
import { debounceTime } from 'rxjs/operators';
import * as fromStore from '../../../store';
import { BrowserSizeName } from './browser.types';

const RESIZE_DEBOUNCE_MS = 100;
const BREAKPOINT_SMALL_MAX = 766;
const BREAKPOINT_MEDIUM_MAX = 1024;

@Injectable({
  providedIn: 'root',
})
export class BrowserService {
  private readonly store = inject<Store<fromStore.State>>(Store);

  sizeName: BrowserSizeName;

  height: number;

  width: number;

  constructor() {
    this.checkWidth();

    if (typeof window !== 'undefined') {
      fromEvent(window, 'resize')
        .pipe(debounceTime(RESIZE_DEBOUNCE_MS))
        .subscribe(() => {
          this.checkWidth();
        });
    }
  }

  public checkWidth(): void {
    if (typeof window === 'undefined') {
      return;
    }

    this.width = window.innerWidth;
    this.height = window.innerHeight;
    this.sizeName = BrowserSizeName.Large;
    if (this.width <= BREAKPOINT_SMALL_MAX) {
      this.sizeName = BrowserSizeName.Small;
    } else if (this.width <= BREAKPOINT_MEDIUM_MAX) {
      this.sizeName = BrowserSizeName.Medium;
    }

    this.store.dispatch(new fromStore.UpdateBrowserSizeName(this.sizeName));
    this.store.dispatch(new fromStore.UpdateBrowserHeight(this.height));
    this.store.dispatch(new fromStore.UpdateBrowserWidth(this.width));
  }
}
